import { useSearchParams } from '@namespace/router';
import { useUserInfoLoaded } from '@namespace/user';
import { useGamesData, useGetPagination } from '../../../store';
import { useGetFeedName } from '../../useGetFeedName';

export const useGetPlexPaginationCommonData = (casinoType, pageProp) => {
  const gamesData = useGamesData();
  const { page } = useSearchParams();
  const feedName = useGetFeedName(casinoType);
  const plexPagination = useGetPagination();
  const { userInfoLoaded } = useUserInfoLoaded();

  const formattedPageFromUrl = page ? Number(page) : 1;

  return {
    gamesData,
    feedName,
    plexPagination,
    userInfoLoaded,
    formattedPage: pageProp || formattedPageFromUrl
  };
};
